import { render, staticRenderFns } from "./bulkfield.vue?vue&type=template&id=a4e7c170"
import script from "./bulkfield.vue?vue&type=script&lang=ts"
export * from "./bulkfield.vue?vue&type=script&lang=ts"
import style0 from "./bulkfield.vue?vue&type=style&index=0&id=a4e7c170&lang=scss"


/* normalize component */
import normalizer from "!../../.yarn/__virtual__/vue-loader-virtual-bcca2229bc/0/cache/vue-loader-npm-15.11.1-829412283a-509a816d45.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/.yarn/cache/vue-hot-reload-api-npm-2.3.4-549ae26337-9befc0b3d6.zip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4e7c170')) {
      api.createRecord('a4e7c170', component.options)
    } else {
      api.reload('a4e7c170', component.options)
    }
    module.hot.accept("./bulkfield.vue?vue&type=template&id=a4e7c170", function () {
      api.rerender('a4e7c170', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bulkfield.vue"
export default component.exports